import { Pagination, Select, Table } from 'antd';
import PropTypes from 'prop-types';

const { Option } = Select;

export const TableCustom = ({ columns = [], dataSource = [], totalItem = 0, params = { page: 1, limit: 10 }, setParams, loading = false }) => {
  return (
    <Table
      rowKey="id"
      columns={columns}
      dataSource={dataSource}
      loading={loading}
      pagination={false}
      scroll={{ x: 750 }}
      tableLayout="auto"
      footer={
        totalItem
          ? () => (
              <div className="flex flex-row justify-between">
                <Pagination
                  pageSize={params?.limit}
                  showSizeChanger={false}
                  current={params?.page}
                  total={totalItem}
                  onChange={(page) => setParams({ ...params, page: page })}
                />
                <div className="flex flex-row justify-end items-center gap-2">
                  {/* Dropdown cho defaultPageSize */}
                  <Select
                    showSearch
                    value={params?.limit}
                    onChange={(value) => setParams({ ...params, page: 1, limit: value })}
                  >
                    <Option value={10}>10</Option>
                    <Option value={20}>20</Option>
                    <Option value={50}>50</Option>
                  </Select>
                  <div className="text-sm text-[#667085] font-medium">
                    Hiển thị từ {totalItem ? (params?.page - 1) * params?.limit + 1 : 0} -{' '}
                    {params?.page * params?.limit > totalItem ? totalItem : params?.page * params?.limit} của{' '}
                    {totalItem}
                  </div>
                </div>
              </div>
            )
          : null
      }
      bordered
      rowClassName={(record, index) =>
        index % 2 === 0 ? 'bg-gray-100 hover:bg-gray-200' : 'bg-white hover:bg-gray-200'
      }
      className="bg-white border rounded-lg"
    />
  );
};

TableCustom.propTypes = {
  columns: PropTypes.arrayOf(PropTypes.object).isRequired,
  dataSource: PropTypes.array,
  totalItem: PropTypes.number,
  params: PropTypes.object,
  setParams: PropTypes.func,
  loading: PropTypes.bool,
};
